import { render, staticRenderFns } from "./WidgetCategoryReviewsBestGalleryMobile.vue?vue&type=template&id=7b7dc4f6"
import script from "./WidgetCategoryReviewsBestGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsBestGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports